module.exports = __webpack_public_path__ + "static/media/chat.bd64a51b.svg";